module.exports = require("css.escape");


//////////////////
// WEBPACK FOOTER
// external "css.escape"
// module id = 481
// module chunks = 0